import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import media from '../media';
import { sizes } from '../breakpoints';
import { isDefined } from '../helpers/defined';
var SPACING = {
  xs: 16,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
};
/* prettier-ignore */

export var scaledCss = function scaledCss(cssKey, size, scales) {
  return "\n  " + cssKey + ": " + SPACING[size] * scales.scale + "px;\n\n  " + (isDefined(scales.yScale) ? "\n    " + cssKey + "-top: " + SPACING[size] * scales.yScale + "px;\n    " + cssKey + "-bottom: " + SPACING[size] * scales.yScale + "px;\n  " : '') + "\n  " + (isDefined(scales.vScale) ? "\n    " + cssKey + "-top: " + SPACING[size] * scales.vScale + "px;\n    " + cssKey + "-bottom: " + SPACING[size] * scales.vScale + "px;\n  " : '') + "\n\n  " + (isDefined(scales.xScale) ? "\n    " + cssKey + "-left: " + SPACING[size] * scales.xScale + "px;\n    " + cssKey + "-right: " + SPACING[size] * scales.xScale + "px;\n  " : '') + "\n  " + (isDefined(scales.hScale) ? "\n    " + cssKey + "-left: " + SPACING[size] * scales.hScale + "px;\n    " + cssKey + "-right: " + SPACING[size] * scales.hScale + "px;\n  " : '') + "\n\n  " + (isDefined(scales.lScale) ? "\n    " + cssKey + "-left: " + SPACING[size] * scales.lScale + "px;\n  " : '') + "\n\n  " + (isDefined(scales.rScale) ? "\n    " + cssKey + "-right: " + SPACING[size] * scales.rScale + "px;\n  " : '') + "\n\n  " + (isDefined(scales.tScale) ? "\n    " + cssKey + "-top: " + SPACING[size] * scales.tScale + "px;\n  " : '') + "\n\n  " + (isDefined(scales.bScale) ? "\n    " + cssKey + "-bottom: " + SPACING[size] * scales.bScale + "px;\n  " : '') + "\n";
};
export var containerSizeMixin = function containerSizeMixin(size) {
  return media.only[size](_templateObject(), function (_ref) {
    var _ref$p = _ref.p,
        p = _ref$p === void 0 ? 1 : _ref$p,
        py = _ref.py,
        px = _ref.px,
        pv = _ref.pv,
        ph = _ref.ph,
        pl = _ref.pl,
        pr = _ref.pr,
        pt = _ref.pt,
        pb = _ref.pb;
    return (
      /* prettier-ignore */
      scaledCss('padding', size, {
        scale: p,
        yScale: py,
        xScale: px,
        vScale: pv,
        hScale: ph,
        lScale: pl,
        rScale: pr,
        tScale: pt,
        bScale: pb
      })
    );
  }, function (_ref2) {
    var _ref2$m = _ref2.m,
        m = _ref2$m === void 0 ? 0 : _ref2$m,
        my = _ref2.my,
        mx = _ref2.mx,
        mv = _ref2.mv,
        mh = _ref2.mh,
        ml = _ref2.ml,
        mr = _ref2.mr,
        mt = _ref2.mt,
        mb = _ref2.mb;
    return (
      /* prettier-ignore */
      scaledCss('margin', size, {
        scale: m,
        yScale: my,
        xScale: mx,
        vScale: mv,
        hScale: mh,
        lScale: ml,
        rScale: mr,
        tScale: mt,
        bScale: mb
      })
    );
  });
};
export var containerMixin = css(_templateObject2(), sizes.map(function (size) {
  return containerSizeMixin(size);
}));
export var containerKeys = ['m', 'mx', 'my', 'mh', 'mv', 'mt', 'mr', 'mb', 'ml', 'p', 'px', 'py', 'ph', 'pv', 'pt', 'pr', 'pb', 'pl'];